import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import AuthContext from "context/auth/authContext";
import TableContext from "context/table/tableContext";
import { useMediaQueries } from "shared/hooks/useMediaQueries";
import {
    filterDropdownCustomMargin,
    generalFiltersBlockStyle
} from "shared/styles/styles";
import { FILTER_NAMES } from "shared/types/enums";

import FilterButton from "../components/FilterButton";
import FilterMenu from "../components/FilterMenu";
import FilterDropdown from "../FilterDropdown";
import { useFilters } from "../hooks";

export const UserFilters = () => {
    const { isSupportUser } = useContext(AuthContext);
    const { hasNoPermissionToRead } = useContext(TableContext);

    const { t } = useTranslation();
    const { toLg, fromLg } = useMediaQueries();
    const { anchorEl, handleOpenMenu, handleCloseMenu } = useFilters();

    return (
        <div css={css(generalFiltersBlockStyle)}>
            {fromLg && (
                <FilterDropdown
                    filter={FILTER_NAMES.Status}
                    placeholder={t("Filter##user status")}
                    disabled={hasNoPermissionToRead}
                    css={css([filterDropdownCustomMargin])}
                />
            )}

            <FilterButton
                onOpen={handleOpenMenu}
                isDisabled={hasNoPermissionToRead}
            >
                {fromLg ? t("Button##more filters") : t("Button##filters")}
            </FilterButton>

            <FilterMenu
                isOpen={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleCloseMenu}
            >
                <div
                    css={css({
                        "& > div + div": {
                            marginTop: "12px"
                        }
                    })}
                >
                    {toLg && (
                        <FilterDropdown
                            filter={FILTER_NAMES.Status}
                            placeholder={t("Filter##user status")}
                        />
                    )}

                    <FilterDropdown
                        filter={FILTER_NAMES.RoleId}
                        placeholder={t("Filter##role")}
                    />

                    {isSupportUser && (
                        <FilterDropdown
                            filter={FILTER_NAMES.AccessGroup}
                            placeholder={t("Filter##access group")}
                        />
                    )}
                </div>
            </FilterMenu>
        </div>
    );
};
